import { useNavigate } from 'react-router-dom';
import { default as svg } from './success.svg';
import styles from './ReferredPage.module.css';
import { ReferralNextSteps } from '../ReferralNextSteps';
import { Button, classList } from '@percihealth/react';

// The post-submit "thank you" page of the referral portals. Copy is the only
// per-brand difference; message={null} drops the body paragraph entirely.
export const ReferredPage = ({
  heading = 'Thank you for your referral',
  message = 'Our nursing team is now processing your patient and will be in contact soon.',
}: {
  heading?: string;
  message?: string | null;
}) => {
  const navigate = useNavigate();
  return (
    <>
      <main className={classList('grid-outer main', styles.main)}>
        <img src={svg} className={styles.img} />
        <p
          className={classList(
            styles.header,
            message ? undefined : styles['header-no-message'],
          )}
        >
          {heading}
        </p>
        {message && (
          <>
            <p className={styles.message}>{message}</p>
            <br />
          </>
        )}
        <Button className={styles.btn} onClick={() => navigate('/')}>
          New referral
        </Button>
        <a className={styles.homepage} href="https://www.percihealth.com">
          Or return to the homepage
        </a>
      </main>
      <ReferralNextSteps />
    </>
  );
};
